/**
 * Orden alfabético para listados del superadmin (insensible a tildes y mayúsculas).
 */
export const normalizarTextoOrden = (texto) => {
    if (texto == null || texto === '') return '';
    return String(texto)
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();
};

export const compararAlfabetico = (a, b, key = 'nombre') => {
    const ta = normalizarTextoOrden(typeof a === 'object' ? a?.[key] : a);
    const tb = normalizarTextoOrden(typeof b === 'object' ? b?.[key] : b);
    return ta.localeCompare(tb, 'es', { sensitivity: 'base' });
};

export const ordenarListaAlfabetica = (lista, key = 'nombre') => {
    if (!Array.isArray(lista)) return [];
    return [...lista].sort((a, b) => compararAlfabetico(a, b, key));
};
